import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/base.less'
import './utils/devTool.js' // 导入开发文件
// import 'video.js/dist/video-js.css'
import 'xgplayer/dist/index.min.css';

Vue.config.productionTip = false

// 多语言
import VueI18n from 'vue-i18n';
import en from './lang/en'
import ja from './lang/ja'
import cn from './lang/cn'
import tw from './lang/tw'
import vi from './lang/vi'
Vue.use(VueI18n);
let initLang = localStorage.getItem("lang")
if (!initLang) {
  initLang = "vi"
  localStorage.setItem("lang", initLang)
}
const i18n = new VueI18n({
  globalInjection: true,
  locale: initLang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: { en, ja, cn, tw, vi }
});

// 导入 vant 组件库
import Vant from 'vant';
import { Toast } from 'vant';
import '@vant/touch-emulator';
import 'vant/lib/index.css';
import setVantLang from './lang/vantLang';
Toast.setDefaultOptions({ overlay: true, closeOnClickOverlay: true });
Toast.setDefaultOptions('loading', { duration: 0, closeOnClickOverlay: false });
setVantLang(initLang)
Vue.use(Vant);

// 导入 swiper 组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)

// 导入 http 插件
import { http, imgUpload } from './http'
Vue.prototype.$http = http
Vue.prototype.$imgUpload = imgUpload


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
